import { HierarchyArsObjects } from "contexts/hierarchy/interface";
import { getArsObjectNameSaveBlocker } from "./getArsObjectNameSaveBlocker";
import { ISaveBlocker } from "./interface";

/**
 * Derives ARS object save blockers from a hierarchy.
 *
 * @param hierarchy - The hierarchy whose ARS object names are validated.
 * @returns A set of save blockers related to invalid ARS object names.
 */
export const getArsSaveBlockers = async (
  hierarchy: HierarchyArsObjects,
): Promise<Set<ISaveBlocker>> => {
  const blockers = await Promise.all([
    ...hierarchy.analysisMethods.map((item) =>
      getArsObjectNameSaveBlocker(item, hierarchy.analysisMethods, "Analysis method"),
    ),
    ...hierarchy.analysisSets.map((item) =>
      getArsObjectNameSaveBlocker(item, hierarchy.analysisSets, "Analysis set"),
    ),
    ...hierarchy.dataSubsets.map((item) =>
      getArsObjectNameSaveBlocker(item, hierarchy.dataSubsets, "Data subset"),
    ),
    ...hierarchy.groupingFactors.map((item) =>
      getArsObjectNameSaveBlocker(item, hierarchy.groupingFactors, "Grouping factor"),
    ),
  ]);

  return new Set(blockers.filter((blocker): blocker is ISaveBlocker => blocker !== undefined));
};
